module.exports = __webpack_public_path__ + "static/img/2826_phase_function_Paper_PointsHejduk_Prediction.9200288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2826_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ayiG
// module chunks = 0